import React from 'react';
import {
	CheckCircleFilledIcon,
	ExclamationCircleFilledIcon,
	ExclamationTriangleFilledIcon,
	IconProps,
	InfoCircleFilledIcon,
	CouponIcon,
	GiftCardIcon,
	SparkleIcon
} from '@eds-web/react';
import {EdsIcon} from '@common/hygraph-schema';

export type EdsIconElement = React.ReactElement<
	IconProps,
	string | React.JSXElementConstructor<any>
>;

type EdsIconComponent = React.ComponentType<IconProps>;

/** Map Hygraph `EdsIcon` enum values to EDS icon components. Extend as needed. */
export const EDS_ICON_MAP: Record<EdsIcon, EdsIconComponent> = {
	[EdsIcon.InfoCircleFilledIcon]: InfoCircleFilledIcon,
	[EdsIcon.SparkleIcon]: SparkleIcon,
	[EdsIcon.CheckCircleFilledIcon]: CheckCircleFilledIcon,
	[EdsIcon.ExclamationCircleFilledIcon]: ExclamationCircleFilledIcon,
	[EdsIcon.ExclamationTriangleFilledIcon]: ExclamationTriangleFilledIcon,
	[EdsIcon.GiftCardIcon]: GiftCardIcon,
	[EdsIcon.CouponIcon]: CouponIcon
};

export const getEdsIcon = (
	icon?: EdsIcon | null,
	props?: IconProps
): EdsIconElement | undefined => {
	if (!icon) return undefined;
	const Icon = EDS_ICON_MAP[icon];
	return Icon ? <Icon {...props} /> : undefined;
};
